<template>
  <div v-editable="blok">
    <div
      class="flex h-full"
      :class="{
        'justify-start': blok.horizontal_alignment === 'left',
        'justify-center': blok.horizontal_alignment === 'center',
        'justify-end': blok.horizontal_alignment === 'right',
      }"
    >
      <div
        class="flex flex-col"
        :class="{
          'justify-start': blok.vertical_alignment === 'top',
          'justify-center': blok.vertical_alignment === 'center',
          'justify-end': blok.vertical_alignment === 'bottom',
        }"
      >
        <h2 v-if="blok.heading" class="mb-7 text-xl">{{ blok.heading }}</h2>
        <ul class="flex flex-col gap-5">
          <component
            :is="entry.component"
            v-for="entry in blok.features"
            :key="entry._uid"
            :blok="entry"
          />
        </ul>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import type { SbFeatureList } from '~/cms/storyblok/types/storyblok.d.ts'

export default defineComponent({
  name: 'FeatureList',
  props: {
    blok: {
      type: Object as PropType<SbFeatureList>,
      required: true,
    },
  },
})
</script>
